"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const reactstrap_1 = require("reactstrap");
const react_1 = __importDefault(require("react"));
exports.TableRowActions = ({ selected, actions, selectRow, actionDispatcher, }) => {
    const isDisabled = !selected.length || !selectRow;
    return (react_1.default.createElement(reactstrap_1.UncontrolledDropdown, null,
        react_1.default.createElement(reactstrap_1.DropdownToggle, { disabled: isDisabled, caret: true, size: "sm", className: `text-truncate`, color: "primary" },
            react_1.default.createElement("span", null, "Actions")),
        react_1.default.createElement(reactstrap_1.DropdownMenu, null, actions.map((action) => (react_1.default.createElement(reactstrap_1.DropdownItem, { key: JSON.stringify(action), className: "cursor-pointer", disabled: action.disabled, onClick: () => actionDispatcher({
                ...action,
                action: action.type,
                creator: { rows: selected },
                params: { rows: selected },
            }) },
            react_1.default.createElement("span", null,
                react_1.default.createElement("i", { className: `fa ${action.icon} mr-2` }, " ")),
            action.label))))));
};
//# sourceMappingURL=TableRowActions.js.map